import React, {PropsWithChildren} from "react";
import {useSelector} from "react-redux";
import {DefaultTheme, ThemeProvider} from "styled-components";
import {getTheme} from "modules/selectors";

export const HOCThemeAdapter: React.FC<PropsWithChildren> = ({children}) => {
	const theme = useSelector(getTheme);
	return <ThemeProvider theme={theme as unknown as DefaultTheme}>{children}</ThemeProvider>;
};
